import React from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { Dropdown } from "semantic-ui-react";
import styles from "./AdminMenu.module.scss";

const AdminMenu: React.FC = () => {
  const intl = useIntl();
  return (
    <Dropdown item text="Admin" className={styles.self}>
      <Dropdown.Menu>
        <Link className={styles.link} to="/admin">
          <Dropdown.Item
            icon="settings"
            text={intl.formatMessage({
              id: "admin.dashboard.title",
              defaultMessage: "dashboard",
            })}
          />
        </Link>
        <Link className={styles.link} to="/admin/users">
          <Dropdown.Item
            icon="user outline"
            text={intl.formatMessage({
              id: "site.users",
              defaultMessage: "users",
            })}
          />
        </Link>
        <Link className={styles.link} to="/admin/patterns">
          <Dropdown.Item
            icon="list alternate"
            text={intl.formatMessage({
              id: "site.patterns",
              defaultMessage: "patterns",
            })}
          />
        </Link>
        <Link className={styles.link} to="/admin/orders">
          <Dropdown.Item
            icon="shopping cart"
            text={intl.formatMessage({
              id: "site.orders",
              defaultMessage: "orders",
            })}
          />
        </Link>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default AdminMenu;
